module.exports = __webpack_public_path__ + "static/media/Moddervis.c8226287.png";